import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestCount = 0;
  private localRequestCount = 0;
  private readonly loaderSubject = new BehaviorSubject<boolean>(false);
  private readonly localLoaderSubject = new BehaviorSubject<boolean>(false);
  loaderState = this.loaderSubject.asObservable();
  localLoaderState = this.localLoaderSubject.asObservable();

  show() {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loaderSubject.next(true);
    }
  }

  hide() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
    if (this.requestCount === 0) {
      this.loaderSubject.next(false);
    }
  }

  showLocal() {
    this.localRequestCount++;
    if (this.localRequestCount === 1) {
      this.localLoaderSubject.next(true);
    }
  }

  hideLocal() {
    if (this.localRequestCount > 0) {
      this.localRequestCount--;
    }
    if (this.localRequestCount === 0) {
      this.localLoaderSubject.next(false);
    }
  }
}
